<template>
  <div class="kt-portlet mt-5 mt-md-3 mt-lg-0">
    <div
      class="kt-portlet__head kt-portlet__head kt-portlet__head--lg
       kt-portlet__head--noborder kt-portlet__head--break-sm flex-wrap"
    >
      <div class="kt-portlet__head-label pt-3 pt-md-0">
        <span class="kt-portlet__head-icon">
          <i class="fal fa-chart-bar"></i>
        </span>
        <h3 class="kt-portlet__head-title">Progress Report</h3>
      </div>
      <div class="kt-portlet__head-toolbar">
        <div class="kt-portlet__head-group d-flex flex-wrap justify-center">
          <!-- <v-btn
            color="primary"
            dark
            depressed
            @click="exportData()"
            :loading="warningDialog"
            text
            disabled
            class="mt-3 mt-md-0 mx-1"
          >
            <v-icon left>fal fa-file-export</v-icon>
            Export Data
          </v-btn> -->

          <!-- <v-snackbar :timeout="0" v-model="warningDialog">
            Progress Report is exporting. Please wait!
            <v-progress-circular
              :size="20"
              class="mx-5"
              color="white"
              indeterminate
            ></v-progress-circular>
          </v-snackbar> -->
        </div>
      </div>
    </div>
    <div class="kt-portlet__body">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-row>
            <v-col>
              <v-menu
                  ref="dateMenu"
                  v-model="dateMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                      style="margin-top: 1.05rem"
                      :value="formattedCertificateDateRange"
                      label="Certificate Date Range"
                      prepend-icon="fal fa-calendar"
                      v-on="on"
                      clearable
                      @click:clear="clearDateRange"
                      clear-icon="fal fa-times-circle"
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="certificateDateRange"
                    range
                    locale="en-US"
                    no-title
                    color="blue"
                    value="mm-dd-YYYY"
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="info" @click="dateMenu = false"
                  >Cancel</v-btn
                  >
                  <v-btn text color="info" @click="fetchData(1)">OK</v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col>
              <v-autocomplete
                  @blur="searchDealership"
                  v-model="selectedDealership"
                  label="Search Dealers"
                  chips
                  multiple
                  :items="specificDealerListSource"
                  item-text="name"
                  item-value="id"
                  v-if="isAccountManager"
              >
              </v-autocomplete>
            </v-col>
            <v-col>
              <v-combobox
                  v-bind="attrs"
                  v-on="on"
                  v-model="search"
                  label="Search Names"
                  multiple
                  chips
                  :disabled="isLoading"
                  @keyup="renderSearch"
              >
              </v-combobox>
            </v-col>
          </v-row>
        </template>
        <span>To search multiple names, type the name and click enter</span>
      </v-tooltip>
      <v-data-table
        :headers="headers"
        :loading="isLoading"
        loading-text="Loading... Please wait"
        :items="statistics"
        :options.sync="options"
        :server-items-length="pagination.total"
        :items-per-page="pagination.per_page"
        :footer-props="{ disablePagination: paginationDisable }"
        class="elevation-1"
      >
        <template
          v-for="h in headers"
          v-slot:[`header.${h.value}`]="{ header }"
        >
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <span v-on="on">{{ h.text }}</span>
            </template>
            <span>{{ h.tooltip }}</span>
          </v-tooltip>
        </template>
        <template #item.units_completed="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                target="_blank"
                color="primary"
                text
                v-bind="attrs"
                v-on="on"
                @click="
                  getCompleted(
                    item.id,
                    'date_completed',
                    title_list[0],
                    item.units_completed
                  )
                "
              >
                {{ item.units_completed }}
              </v-btn>
            </template>
            <span>{{ item.units_completed == 0 ? 'No Result' : 'View' }}</span>
          </v-tooltip>
        </template>
        <template #item.video_finished="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                target="_blank"
                color="primary"
                text
                v-bind="attrs"
                v-on="on"
                @click="
                  getCompleted(
                    item.id,
                    'finished_watching',
                    title_list[1],
                    item.video_finished
                  )
                "
              >
                {{ item.video_finished }}
              </v-btn>
            </template>
            <span>{{ item.video_finished == 0 ? 'No Result' : 'View' }}</span>
          </v-tooltip>
        </template>
        <template #item.certificates="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                target="_blank"
                color="primary"
                text
                v-bind="attrs"
                v-on="on"
                @click="
                  getCertificate(item)
                "
              >
                {{ item.certificates }}
              </v-btn>
            </template>
            <span>{{ item.certificates == 0 ? 'No Result' : 'View' }}</span>
          </v-tooltip>
        </template>
        <template #item.unfinished_assigned_module="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                target="_blank"
                color="primary"
                text
                v-bind="attrs"
                v-on="on"
                @click="
                  getUnfinishedModule(
                    item.id,
                    title_list[3],
                    item.unfinished_assigned_module
                  )
                "
              >
                {{ item.unfinished_assigned_module }}
              </v-btn>
            </template>
            <span>{{
              item.unfinished_assigned_module == 0 ? 'No Result' : 'View'
            }}</span>
          </v-tooltip>
        </template>
        <template #item.unfinished_assigned_playlist="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                target="_blank"
                color="primary"
                text
                v-bind="attrs"
                v-on="on"
                @click="
                  getUnfinishedPlaylist(
                    item.id,
                    title_list[4],
                    item.unfinished_assigned_playlist
                  )
                "
              >
                {{ item.unfinished_assigned_playlist }}
              </v-btn>
            </template>
            <span>{{
              item.unfinished_assigned_playlist == 0 ? 'No Result' : 'View'
            }}</span>
          </v-tooltip>
        </template>
      </v-data-table>
      <unit-modal
        :key="'unit-' + unitModalKey"
        v-model="showUnitModal"
        :units="units"
        :isPlaylist="isPlaylist"
        :title="title"
      />

      <module-modal
        :key="'module-' + moduleModalKey"
        v-model="showModuleModal"
        :modules="modules"
        :title="title"
      />
      <certificates-modal
          v-model="showCertificateModal"
          :certificates="certificates"
          :update-row="updateRow"
      ></certificates-modal>
    </div>
  </div>
</template>

<script>
import UnitModal from './UnitModal';
import ModuleModal from './ModuleModal';
import {
  each as _each,
  some as _some,
  isEmpty as _isEmpty,
  debounce as _debounce,
  sortBy as _sortBy,
  findIndex as _findIndex
} from 'lodash-es'
import CertificatesModal from './CertificatesModal'
import DatePicker from '../../dashboard/DatePicker'

export default {
  name: 'ProgressReport',
  components: {
    DatePicker,
    CertificatesModal,
    UnitModal,
    ModuleModal,
  },
  computed: {
    formattedCertificateDateRange() {
      return this.formatDateRangeForTextField(this.certificateDateRange);
    },
    isAccountManager() {
      return _some(this.$auth.user().roles, { name: 'account-manager' });
    },
  },
  data() {
    return {
      dateMenu: false,
      temporaryCertificateDateRange: [],
      certificateDateRange: [],
      certificates: [],
      showCertificateModal: false,
      selectedDealership: [],
      specificDealerListSource: [],
      onProcess: false,
      warningDialog: false,
      selectSelect: [],
      isPlaylist: false,
      isLoading: false,
      search: '',
      showUnitModal: false,
      unitModalKey: 0,
      moduleModalKey: 0,
      showModuleModal: false,
      title: '',
      title_list: [
        'Units/Videos | Answered Quiz / Marked as Completed',
        'Units/Videos | Videos Finished',
        'Units/Videos | Certificates / Finished Modules',
        'Units/Videos | Unfinished in Assigned Module',
        'Units/Videos | Unfinished in Assigned Playlist',
      ],
      units: [],
      modules: [],
      headers: [
        {
          text: 'Name',
          tooltip: 'Name of Salesperson',
          align: 'start',
          sortable: true,
          value: 'name',
        },
        {
          text: 'Role',
          tooltip: 'User role',
          value: 'role',
          align: 'center',
        },
        {
          text: 'Total Number of Modules',
          tooltip: 'Total Number of Modules',
          value: 'total_number_of_modules',
          align: 'center',
        },
        {
          text: 'Number Of Completed Modules',
          tooltip: 'Total number of completed modules',
          value: 'completed_modules',
          align: 'center',
        },
        {
          text: 'Certificates',
          tooltip: 'Total number of certificates earned',
          value: 'certificates',
          align: 'center',
        },
      ],
      statistics: [],
      pagination: {
        total: 1,
        per_page: 10,
        current_page: 1,
        search: '',
        sortBy: '',
        sortDesc: false,
      },
      options: {},
      paginationDisable: false,
      timeout: null,
      date: [],
    };
  },
  watch: {
    options: {
      handler() {
        this.changeTable();
      },
      deep: true,
    },
  },
  created() {
    this.fetchData();
    this.getDealers();
  },
  beforeDestroy() {
    this.destroyCache();
  },
  methods: {
    clearDateRange() {
      this.certificateDateRange = [];
      this.fetchData(1);
    },
    formatDateRangeForTextField(date) {
      if (date) {
        date.filter(function (str) {
          return /\S/.test(str);
        });
        date = date.map(function (date) {
          if (date) {
            return new Date(date).toLocaleDateString('en-US');
          }
        });
      }
      return date.join('~');
    },
    getDealers() {
      this.$http.get('/dealers').then(({ data }) => {
        this.specificDealerListSource = [];
        _each(data, (dealer) => {
          if (dealer.id === this.$auth.user().dealer_id) {
            _each(dealer.specific_dealers, (specificDealer) => {
              this.specificDealerListSource.push({
                name: specificDealer.name,
                id: specificDealer.id,
              });
            });
          }
        });
        this.specificDealerListSource = _sortBy(this.specificDealerListSource, ['name']);
      });
    },
    destroyCache() {
      this.$http.delete('/client/reports/lms/progress/destroy-cache');
    },
    renderSearch() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.options.page = 1;
        this.changeTable();
      }, 1000);
    },
    searchDealership: _debounce(function() {
      this.fetchData(1);
    }, 500),
    fetchData(page = 1) {
      this.showCertificateModal = false;
      this.isLoading = true;
      this.paginationDisable = true;
      this.dateMenu = false;
      this.statistics = [];
      console.log(_isEmpty(page) ? this.pagination.current_page : page);
      this.$http
        .get('/client/reports/lms/progress', {
          params: {
            per_page: this.pagination.per_page,
            current_page: _isEmpty(page) ? this.pagination.current_page : page,
            sortBy: this.pagination.sortBy,
            sortDesc: this.pagination.sortDesc,
            search: this.search,
            selectedDealership: this.selectedDealership,
            certificateDateRange: this.certificateDateRange,
          },
        })
        .then((data) => {
          this.statistics = data.data.data;
          this.pagination.total = data.data.total;
          this.pagination.current_page = data.data.current_page;
          this.pagination.per_page = data.data.per_page;
          this.isLoading = false;
          this.paginationDisable = false;
        });
    },
    getCertificate(item) {
      if (item.completed_modules < item.total_number_of_modules) {
        this.$notify('warning', 'Can\'t open certificates section. The completed modules and total numbers of modules are not equal.');
        return;
      }
      this.isLoading = true;
      this.$http
        .get(`/client/reports/lms/progress/get-certificate/${item.id}`)
        .then((data) => {
          this.isLoading = false;
          this.showCertificateModal = true;
          this.certificates = data.data;
        });
    },
    changeTable() {
      this.pagination.current_page = this.options.page;
      this.pagination.sortBy =
        this.options.sortBy !== undefined ? this.options.sortBy[0] : '';
      this.pagination.sortDesc =
        this.options.sortDesc !== undefined ? this.options.sortDesc[0] : '';
      this.fetchData();
    },
    showModalUnit(title, items) {
      this.unitModalKey += 1;
      this.title = title;
      this.units = items;
      this.showUnitModal = true;
    },
    showModalModule(title, items) {
      this.moduleModalKey += 1;
      this.title = title;
      this.modules = items;
      this.showModuleModal = true;
    },
    updateRow(userId) {
      const index = _findIndex(this.statistics, { id: userId });
      this.statistics[index].certificates += 1;
    },
    exportData() {
      this.warningDialog = true;
      this.$http.get(`/client/reports/lms/progress/export`, {
        params: {
          search: this.search,
          selectedDealership: this.selectedDealership
        },
      }).then(({ data }) => {
        this.warningDialog = false;
        this.$notify('success', data.message);
      });
    },
  },
};
</script>

<style lang="stylus">
.item-link
  text-decoration underline
.v-snack__content
  justify-content center
</style>
